
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class DelhiveryApiDetailsGrid extends Serenity.EntityGrid<DelhiveryApiDetailsRow, any> {
        protected getColumnsKey() { return DelhiveryApiDetailsColumns.columnsKey; }
        protected getDialogType() { return DelhiveryApiDetailsDialog; }
        protected getIdProperty() { return DelhiveryApiDetailsRow.idProperty; }
        protected getInsertPermission() { return DelhiveryApiDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return DelhiveryApiDetailsRow.localTextPrefix; }
        protected getService() { return DelhiveryApiDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}